import React from 'react'
import AuthRoutes from "./AuthRoutes/Supervisor"
import UnauthRoutes from './UnauthRoutes';
import { useSelector } from 'react-redux';
import { ROLE_CHECKER } from '../constants';
import CheckerRoutes from './AuthRoutes/Checker';
import SuperVisorRoutes from './AuthRoutes/Supervisor';

const BaseRoutes = () => {
  const user = useSelector(state => state.user);
  return (
    user ? 
      user.role.code === ROLE_CHECKER.value ?
      <CheckerRoutes/>
      :
      <SuperVisorRoutes/>
    :
    <UnauthRoutes />
  )
}

export default BaseRoutes